import { FC } from 'react';
import { Link } from 'react-router';
import { SidebarContent } from 'src/components/Sidebar/components/SidebarContent';
import { useDrawer } from 'src/hooks/useDrawer';
import { SidebarArrow } from 'src/components/svg/Arrows';
import { useRoute } from 'src/router/hooks';
import { Logo } from 'src/config/components/Logo';

export const AsideInner: FC = () => {
  const { ROUTE } = useRoute();
  const { closeDrawer } = useDrawer();

  return (
    <div className="flex flex-col justify-start items-center py-6 text-ga_text min-h-full w-full px-[30px]">
      <div
        onClick={closeDrawer}
        className="toggle-container cursor-pointer toggle-container__opened">
        <SidebarArrow />
      </div>
      <Link to={ROUTE.MAIN.get()} onClick={closeDrawer}>
        <div className="logo logo__opened">
          <Logo />
        </div>
      </Link>

      <div className="w-full flex flex-col justify-start items-center overflow-y-auto h-full">
        <SidebarContent />
      </div>
    </div>
  );
};
